import React from "react";
import { Input } from "antd";
import { Search } from "lucide-react";

const GlobalSearch = ({ value, onChange, placeholder = "Search...", style, className }) => (
  <div className={`flex bg-gray-200 items-center gap-2 rounded-lg px-4 py-2 ${className || ''}`} style={style}>
    <Search className="w-5 h-5 text-gray-400" />
    <Input
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className="border-none bg-transparent focus:ring-0 focus:border-none"
      style={{ width: 300, boxShadow: "none" }}
    />
  </div>
);

export default GlobalSearch;
